<template>
	<div>
		<span class="text-red-600" v-if="validationMessage">{{
			validationMessage
		}}</span>
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		field: {
			type: String,
			required: true,
		},
	},
	computed: {
		validationMessage() {
			return this.form.errors[this.field] || "";
		},
	},
	methods: {
		validationEventListener() {
			if (this.hasForm) {
				let that = this;
				console.log(
					"is-mark-invalid",
					that.field,
					that.markInvalid,
					that.mounted
				);
				that.$bus.$emit("is-mark-invalid", that.field, that.markInvalid);
			}
		},
	},
	created() {
		this.$bus.$on("poll-is-mark-invalid", this.validationEventListener);
	},
	beforeDestroy() {
		console.log("TURNING OFF", this.field);
		this.$bus.$off("poll-is-mark-invalid", this.validationEventListener);
	},
};
</script>
